import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, Input, Output, EventEmitter, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { LoaderService } from '../../services/loader.service';
import { UserService } from '../../services/user.service';
import { ApiService } from '../../services/api.service';
import { environment } from 'src/environments/environment';
import { AppConstants } from '../../constants/app.contants';
import { lastValueFrom } from 'rxjs';
import { BaseResponseDTO } from 'src/app/core/models/app.models';
import { Message } from '../../models/app.models';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FormValidationService } from 'src/app/shared/services/form-validation.service';
import { MessageService } from '../../services/MessageService.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-chat-popup',
  templateUrl: './chat-popup.component.html',
  styleUrls: ['./chat-popup.component.scss']
})
export class ChatPopupComponent implements OnInit {
  @ViewChild('chatBody') chatBody: ElementRef;

  
  @Input() selectedMessage: any; // Selected message object
  isChatVisible: boolean = false; // Toggle chat visibility
  messages: any[] = [];  // Array of messages
  showChatButton: boolean = false; // To control the visibility of the chat button
  form: FormGroup;
  initialized : boolean = false;
  MsgDTO: any = {}; // Global variable to hold the result
  constructor(
    
    private _router: Router,
    private _activeRoute : ActivatedRoute,
    private _formBuilder: FormBuilder,
    private _http: HttpClient,
    private messageService: MessageService,
    private _loaderService: LoaderService,
    private _userService: UserService,
    private formValidationService: FormValidationService,
    private fb: FormBuilder,
    ) {}

  ngOnInit(): void {


    this.showChatButton = false;
    this.isChatVisible = false;
       this.form = this.fb.group({
          message: ['']  // Initialize message input with an empty string
        });


    // Subscribe to router events and check the current route
    this._router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.checkRoute(event.urlAfterRedirects);
        this.initialized = true; // Set the flag to true after the first navigation

      }
    });
    if(!this.initialized) {
      this.initialized = false; 
      this.checkRoute(this._router.url);
    }

    // Subscribe to messages from the service
    this.messageService.messages$.subscribe(messages => {
      this.messages = messages;
    });

  }

  closeChatIcon(): void {
    this.showChatButton = false; // Hides the chat icon
  }

  
  async retrieveMessages(msgDTO: any): Promise<void> {
    try {
      this._loaderService.showLoader();

      this.MsgDTO = { module: msgDTO.module, id: msgDTO.referenceID , subid: msgDTO.subReferenceID , displayid  : msgDTO.displayID };
      // Call the message retrieval service
      await this.getMessages(this.MsgDTO);
      this.isChatVisible = false; // Set chat visibility to true
      this.toggleChat();
    } catch (error) {
      console.error('Error retrieving messages:', error);
      this.isChatVisible = false;
      return ; // Return false on error
    } finally {
      this._loaderService.hideLoader();
    }
  }
  
  
  
  // Check the route and hide/show chat button
  checkRoute(currentRoute: string): Promise<void> {
    const hideChatRoutes = ['/login', '/register', '/Messages', '/tender','/financials','/bid','/email']; // Add routes where you want to hide the chat button
    this.showChatButton = !hideChatRoutes.includes(currentRoute);

    if (!this.showChatButton) {
        this.isChatVisible = false;
        return Promise.resolve(); // Explicitly return a resolved promise
    }

    if (this.showChatButton) {
    

        // Check for Bid route
        if (currentRoute.includes('/bid/')) {
            const segments = currentRoute.split('/'); // Split the URL by '/'
            const bidId = segments[segments.length - 1]; // Get the last segment

            if (bidId && bidId.startsWith('TCA-')) {
                // Valid Bid ID
                console.log('Bid ID:', bidId);
                this.MsgDTO = { module: "BiddingChat", id: bidId };
                return this.getMessages(this.MsgDTO);
            }
        }

        // Default to VendorChat
        this.MsgDTO = { module: "VendorChat" };
        return this.getMessages(this.MsgDTO);
    }

    // Fallback return to satisfy all code paths
    return Promise.resolve();
}



  selectMessage(message: any) {
    this.selectedMessage = message;
  }

  toggleChat() {
    this.isChatVisible = !this.isChatVisible;
    if(this.isChatVisible) {
      setTimeout(() => {
        this.scrollToBottom();
       }, 100);
    }
  }

  scrollToBottom(): void { 
    try {
        this.chatBody.nativeElement.scrollTop = this.chatBody.nativeElement.scrollHeight;
    } catch (err) {
        console.error('Error scrolling chat to bottom:', err);
    }
}

 
  // Method to format the date as Today/Yesterday or the specific date and time
  formatDate(dateString: string): string {
    const messageDate = new Date(dateString);
    const today = new Date();

    // Check if the message was sent today
    if (messageDate.toDateString() === today.toDateString()) {
      return `Today, ${messageDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
    }

    // Check if the message was sent yesterday
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    if (messageDate.toDateString() === yesterday.toDateString()) {
      return `Yesterday, ${messageDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
    }

    // Otherwise, return the full date
    return messageDate.toLocaleDateString([], { weekday: 'short', month: 'short', day: 'numeric' }) +
           `, ${messageDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
  }



  sendMessage() {
    const messageContent = this.form.get('message')?.value; // Get the message input
  
    if (messageContent && messageContent.trim() !== '') {
      // const newMessage: Message = {
      //   moudle: this.selectedMessage?.moudle, // Use the module of the selected message
      //   subReferenceNumber: this.selectedMessage?.subReferenceNumber, // Sub-reference number
      //   referenceNumber: this.selectedMessage?.referenceNumber, // Reference number
      //   messageContent: messageContent,
      // };
  
 
      const newMessage: any = {
        direction: 'Outbound', // Assume sending messages are outbound
        Module: this.MsgDTO?.module, // Use the module of the selected message
        vendorID: this.selectedMessage?.vendorID, // Use the vendor ID of the selected message
        subReferenceNumber: this.MsgDTO.subid, // Sub-reference number
        referenceNumber: this.MsgDTO.id, // Reference number
        messageContent: messageContent,
        CreatedAt: new Date().toISOString(), // Set current time
      };

      
    
  
        const apiService = this.createApiService();
  
        new Promise((resolve, reject) => {
          this._loaderService.showLoader();
  
            this.firePostMessage(apiService,newMessage)
            .then((result: any) => {
              let response: BaseResponseDTO = result;
    
              if (response?.isSuccess){
                newMessage.CreatedAt = response.data.createdAt
                newMessage.direction = response.data.direction
  

                // Add the new message to the list of messages
                this.messages.push(newMessage);
  
  
    
                // Scroll to the bottom of the chat after adding the message
                setTimeout(() => {
                 this.scrollToBottom();
                }, 100);
  
                // Clear the message input field
                this.form.get('message')?.reset();
              }
            
              resolve(response);
    
            }).catch((err: HttpErrorResponse) => {
                this._loaderService.hideLoader();
            }).finally(() =>{
                this._loaderService.hideLoader();
            });
    
        });
        
  
  
  
  
    }
  }

   
  private createApiService(): ApiService {
    const apiService = new ApiService(this._http);
    apiService['_baseUrl'] = environment.API_URL; // Set the base URL manually
    return apiService;
  }
  

  async getMessages(msg: Message) {
    const apiService = this.createApiService();
  
     
    const newMessage: any = {
      Module: this.MsgDTO?.module, // Use the module of the selected message
      vendorID: this.selectedMessage?.vendorID, // Use the vendor ID of the selected message
      referenceNumber: this.MsgDTO.id, // Reference number
      SubReferenceNumber: this.MsgDTO.subid ? Number(this.MsgDTO.subid) : 0, // Convert string to number, default to 0 if null or undefined
      messageContent: msg.messageContent,
    };


    new Promise((resolve, reject) => {
      this._loaderService.showLoader();
  
      this.fireGetMessage(apiService, newMessage)
        .then((result: any) => {
          let response: BaseResponseDTO = result;
  
          if (response?.isSuccess) {
            // Assuming the data from backend is stored in `result.result`
            const backendMessages: any[] = result.data;

            if (backendMessages && backendMessages.length > 0) {
        
              this.messages = backendMessages.map(backendMsg => {
                // Get the server time (assuming it's in UTC or UAT)
                const serverTime = new Date(backendMsg.createdAt);
                
                // Convert the server time to local time
                const localTime = new Date(serverTime.getTime() - (serverTime.getTimezoneOffset() * 60000));
              
                return {
                  direction: backendMsg.direction,
                  moudle: backendMsg.moudle,
                  vendorID: backendMsg.vendorID,
                  subReferenceNumber: backendMsg.subReferenceNumber,
                  referenceNumber: backendMsg.referenceNumber,
                  messageContent: backendMsg.messageContent,
                  processID  : backendMsg.processID,
                  CreatedAt: localTime.toLocaleString() // Convert to local time zone
                };
              });
              this.messageService.setMessages(this.messages);

              // Set the first message as selected
              this.selectedMessage = {
                moudle: backendMessages[0].moudle,
                CreatedAt: backendMessages[0].createdAt,
              };
            } else {
              // No messages, set messages to empty array and selectedMessage to null
              this.messages = [];
              this.selectedMessage = null;
            }
          }
  
          resolve(response);
        })
        .catch((err: HttpErrorResponse) => {
          this._loaderService.hideLoader();
        })
        .finally(() => {
          this._loaderService.hideLoader();
        });
    });
  }

private fireGetMessage(apiService: ApiService,payload : Message) {
  let req$ = apiService.post(AppConstants.CONTROLLERS.Messages, AppConstants.ACTIONS.GetMessages, true, environment.APIs_PREFIX,payload);
  return lastValueFrom(req$);
} 


    
private firePostMessage(apiService: ApiService, payload: any) {
  let req$ = apiService.post(AppConstants.CONTROLLERS.Messages, AppConstants.ACTIONS.sendMessage, true, environment.APIs_PREFIX, payload);
  return lastValueFrom(req$);
} 



}
